window.addEventListener("load", () => {
  const submitButton = document.querySelector(".cart__submit");
  if (submitButton) {
    submitButton.replaceWith(submitButton.cloneNode(true));
  }

  const quickCheckoutBtn = document.getElementById("QuickCheckoutBtn");
  if (quickCheckoutBtn) {
    quickCheckoutBtn.addEventListener('click', (event) => {
      event.preventDefault();
      const regularCheckoutButton = document.querySelector("cart__submit");
      if (regularCheckoutButton) {
        regularCheckoutButton.click();
      }
    });
  }
});